import _ from "lodash"
import ActionTypes from "./constants"
import {
  ContainerState,
  ContainerActions,
  AllQuicklookPreviewsType,
} from "./types"

import ApplicationActionTypes from "../application/constants"
import { QuicklookPreviewType } from "../../types/geoMap"
import { objectValues } from "../../helpers/utilsHelper"
import { wetzls } from "../../helpers/innerCircleCalculator"
import {
  calculateDistanceBetween,
  convertCircleCoordinatesIntoShape,
} from "../../helpers/shapeHelper"

export const MAP_INITIAL_DEFAULT = {
  center: [51.505, -0.09],
  zoom: 5,
}

export const initialState: ContainerState = {
  geoMap: null,
  lastShape: null,
  placeSuggestions: [],
  mapInitialAttributes: MAP_INITIAL_DEFAULT,
  allQuicklookPreviews: {},
  searchByProducts: false,
  searchProductIds: [],
  availableCutScenes: [],
  availableScenesToCut: [],
  availableLoadingScenes: [],
  routine: false
}

function geoMapReducer(
  state: ContainerState = initialState,
  action: ContainerActions
): ContainerState {
  switch (action.type) {
    case ActionTypes.HIDE_ALL_QUICKLOOK_PREVIEWS:
      return {
        ...state,
        allQuicklookPreviews: hideAllQuicklookPreviews(
          state.allQuicklookPreviews
        ),
      }

    case ActionTypes.ADD_QUICKLOOK_PREVIEW:
      return !state.allQuicklookPreviews[action.payload.productImageId]
        ? {
          ...state,
          allQuicklookPreviews: {
            ...state.allQuicklookPreviews,
            [action.payload.productImageId]: action.payload,
          },
        }
        : state

    case ActionTypes.UPDATE_QUICKLOOK_PREVIEWS:
      return {
        ...state,
        allQuicklookPreviews: updateQuicklookPreviewsFrom(
          state.allQuicklookPreviews,
          action.payload
        ),
      }

    case ActionTypes.STORE_LAST_SHAPE:
      return { ...state, lastShape: action.payload }

    case ActionTypes.STORE_KML_SHAPE:
      return { ...state, kmlGuideShape: action.payload }

    case ActionTypes.REMOVE_LAST_SHAPE:
      return { ...state, lastShape: null }

    case ActionTypes.CONVERT_LAST_SHAPE_IN_POLYGON_TYPE:
      if (!!state.lastShape) {
        const latlngs =
          state.lastShape?.layer &&
          state.lastShape?.layer[0].map(([lng, lat]) => ({
            x: lng,
            y: lat,
          }))
        const points = wetzls(latlngs)
        const convertedRadius = Math.max(
          ...latlngs.map((elem) => calculateDistanceBetween(elem.x, elem.y, points.x, points.y))
        )
        return !state.routine &&
          (state.lastShape?.layerType === "polygon" ||
            state.lastShape?.layerType === "rectangle")
          ? {
            ...state,
            lastShape: {
              ...state.lastShape,
              ...convertCircleCoordinatesIntoShape(
                parseFloat(points.y),
                parseFloat(points.x),
                convertedRadius
              ),
              inscribedPolygon: {
                layer: [...state.lastShape.layer[0].map(([x, y]) => [y, x])],
              },
            },
          }
          : { ...state }
      }
      return { ...state }

    case ActionTypes.REMOVE_KML_SHAPE:
      return { ...state, kmlGuideShape: null }

    case ActionTypes.SET_SUGGESTIONS:
      return { ...state, placeSuggestions: action.payload }

    case ActionTypes.REMOVE_SUGGESTIONS:
      return { ...state, placeSuggestions: [] }

    case ActionTypes.UPDATE_MAP_POSITION:
      return { ...state, mapInitialAttributes: { ...action.payload } }

    case ActionTypes.SET_GEO_MAP:
      return { ...state, geoMap: action.payload }

    case ActionTypes.SET_SEARCH_BY_PRODUCTS:
      return { ...state, searchByProducts: action.payload }

    case ActionTypes.ADD_LOADINGSCENE:
      return { ...state, availableLoadingScenes: state.availableLoadingScenes.concat([action.payload]) }

    case ActionTypes.REPLACE_LOADINGSCENES:
      return { ...state, availableLoadingScenes: action.payload }

    case ActionTypes.REMOVE_LOADINGSCENE:
      return { ...state, availableLoadingScenes: state.availableLoadingScenes.filter((loadingScene) => loadingScene.id !== action.payload) }

    case ActionTypes.ADD_SCENETOCUT:
      return { ...state, availableScenesToCut: state.availableScenesToCut.concat([action.payload]) }

    case ActionTypes.REPLACE_SCENESTOCUT:
      return { ...state, availableScenesToCut: action.payload }

    case ActionTypes.ADD_CUTSCENE:
      return { ...state, availableCutScenes: state.availableCutScenes.concat([action.payload]) }

    case ActionTypes.REPLACE_CUTSCENES:
      return { ...state, availableCutScenes: action.payload }

    case ActionTypes.SET_SEARCH_PRODUCT_IDS:
      return { ...state, searchProductIds: action.payload }

    case ActionTypes.CHANGE_ROUTINE_STATUS:
      return { ...state, routine: action.payload }

    case ApplicationActionTypes.RESET_SEARCH:
      return {
        ...state,
        allQuicklookPreviews: hideAllQuicklookPreviews(
          state.allQuicklookPreviews
        ),
      }

    default:
      return state
  }
}

const hideAllQuicklookPreviews = (
  allQuicklookPreviews: AllQuicklookPreviewsType
): AllQuicklookPreviewsType => {
  const newQuicklookPreviews = objectValues(allQuicklookPreviews).map(
    (quicklookPreview: QuicklookPreviewType) => {
      return {
        ...quicklookPreview,
        isShownInMap: false,
      }
    }
  )
  return _.keyBy(newQuicklookPreviews, "productImageId")
}

const updateQuicklookPreviewsFrom = (
  allQuicklookPreviews: AllQuicklookPreviewsType,
  newQuicklookPreviews: QuicklookPreviewType[]
) => {
  const qps = _.keyBy(newQuicklookPreviews, "productImageId")
  return {
    ...allQuicklookPreviews,
    ...qps,
  }
}

export default geoMapReducer
